import { render, staticRenderFns } from "./issue-list.vue?vue&type=template&id=08830aeb&scoped=true&"
import script from "./issue-list.vue?vue&type=script&lang=js&"
export * from "./issue-list.vue?vue&type=script&lang=js&"
import style0 from "./issue-list.vue?vue&type=style&index=0&id=08830aeb&prod&lang=scss&"
import style1 from "./issue-list.vue?vue&type=style&index=1&id=08830aeb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08830aeb",
  null
  
)

export default component.exports